<template>
  <div id="app">
    <div v-if="$store.state.appOrH5 !== 'H5'"><router-view /></div>
    <div v-else>
      <iframe
        ref="iframe"
        id="h5Iframe"
        :src="srcIframe"
        frameborder="0"
        scrolling="no"
        rel="noopener"
        class="background-iframe"
      ></iframe>
      <button
        ref="appLogin"
        class="toggle-button"
        :style="buttonStyle"
        @touchstart="handleTouchStart"
        @touchend="handleTouchEnd"
        @click="changeFlag"
        v-show="!$store.state.flag"
      >
        <img v-if="!gameVersion" src="./assets/floatingBox.png" alt="" />
        <img
          class="jf-icon"
          v-if="gameVersion"
          src="./assets/jifen.png"
          alt=""
        />
      </button>
      <router-view v-show="$store.state.flag" :key="$route.fullPath" />
      <!-- <transition name="fade">
      </transition> -->
    </div>
  </div>
</template>

<script>
import postMessageIframe from "./utils/postMessageIframe.js";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  name: "App",
  data() {
    return {
      // flag: true,
      appOrH5: true,
      dragging: false, // 是否正在拖动
      startX: 0,
      startY: 0,
      startMouseX: 0,
      startMouseY: 0,
      // 按钮的默认位置
      buttonStyle: {
        position: "fixed",
        bottom: "20px",
        right: "20px",
      },
      srcIframe: "",
      gameVersion: false,
      isFromOpenService: false,
    };
  },
  watch: {
    // 使用字符串路径观察 Vuex store 中的状态
    "$store.state.Authorization"(newVal) {
      console.log("newVal", newVal);
      if (newVal) {
        // 检查 newVal 是否为真值
        // 执行你需要的操作，例如发送 postMessage
        this.$nextTick(() => {
          this.$set(this, "srcIframe", process.env.VUE_APP_GAME_URL);
          this.$store.state.flag = false;
        });
      } else {
        this.$set(this, "srcIframe", "");
        this.$store.state.flag = true;
      }
      this.$nextTick(() => {
        console.log("srcIframe", this.srcIframe);
      });
    },
  },
  methods: {
    ...mapMutations(["changeToken"]),
    //校验token
    async checkToken() {
      if (this.$store.state.Authorization) {
        try {
          let { data } = await this.$http.post("/auth/refresh");
          console.log("data", data);
          if (data.code === 200) {
            this.$router.push("/redPacket");
            this.$nextTick(() => {
              this.$set(this, "srcIframe", process.env.VUE_APP_GAME_URL);
              this.$store.state.flag = false;
            });
          }
        } catch (error) {
          console.error("刷新token失败:", error);
        } finally {
          setTimeout(() => {
            dsBridge.call("splashPageEnd", function (v) {});
          }, 2000);
        }
      }
    },
    // 获取token 免登录
    async getToken() {
      let that = this;
      dsBridge.call("getToken", async function (data) {
        console.log("getToken", data);
        const data1 = JSON.parse(data);
        if (data1.code === 200) {
          if (data1.data) {
            that.changeToken({
              access_token: data1.data,
            });
            if (window.location.href.includes("pay")) {
              that.$router.push("/pay");
            } else {
              that.$router.push("/redPacket");
            }
          }
        }
      });
    },
    changeFlag() {
      this.$store.state.flag = !this.$store.state.flag;
      this.$router.push({
        path: "/redPacket",
        // path: "/pay",
        // path: "/login",
        query: {
          t: Date.now(), // 时间戳作为唯一标识
        },
      });
      // this.$set(this, "srcIframe", "");
    },
    openCustomerService() {
      // 标记为通过openService进入
      this.isFromOpenService = true;
      this.$router.push({
        path: "/customerService",
      });
    },
    handleTouchStart(event) {
      this.dragging = true;
      const button = this.$refs.appLogin; // 获取按钮元素
      this.startX = button.offsetLeft;
      this.startY = button.offsetTop;
      this.startMouseX = event.touches[0].clientX;
      this.startMouseY = event.touches[0].clientY;
      document.addEventListener("touchmove", this.handleTouchMove);
      document.addEventListener("touchend", this.handleTouchEnd);
    },
    handleTouchMove(event) {
      if (this.dragging) {
        const deltaX = event.touches[0].clientX - this.startMouseX;
        const deltaY = event.touches[0].clientY - this.startMouseY;
        const newX = this.startX + deltaX;
        const newY = this.startY + deltaY;
        this.$refs.appLogin.style.left = `${newX}px`;
        this.$refs.appLogin.style.top = `${newY}px`;
      }
    },
    handleTouchEnd() {
      this.dragging = false;
      document.removeEventListener("touchmove", this.handleTouchMove);
      document.removeEventListener("touchend", this.handleTouchEnd);
    },
    setButtonPosition() {
      // 检查是否是竖屏模式
      if (window.matchMedia("(orientation: portrait)").matches) {
        // 竖屏模式下的样式
        this.buttonStyle = {
          position: "fixed",
          bottom: "20px",
          right: "20px",
          top: "auto",
          left: "auto",
        };
      } else {
        // 横屏模式下的样式
        // 如果你有横屏模式下的特定样式，可以在这里设置
        this.buttonStyle = {
          position: "fixed",
          bottom: "20px",
          right: "20px",
          top: "auto",
          left: "auto",
        };
      }
    },
  },
  created() {
    // 构建时 process.env 会被替换为实际值
    this.gameVersion = process.env.VUE_APP_GAME_VERSION === "jf";
  },
  beforeMount() {
    // postMessageIframe.sendMessageWithCallback(
    //   {
    //     type: "tcLogin",
    //     msg: "eyJhbGciOiJIUzUxMiJ9.eyJ1c2VyX2lkIjoxMDEsInVzZXJfa2V5IjoiNjhmOTJhNDAtZWE5OC00N2RmLWJjYjItNzk1Nzk5OTVjMmZjIiwidXNlcm5hbWUiOiIxNTUyNzYxMjQ4MSJ9.ayuKtV0V4-lTBtqhcEMi8TvYBRJDjn3zJvwF7ujlEeEG8pheOEHFiQL2QtrhmOqYXY4F3moPbQtjnJurWQf9Lw",
    //   },
    //   (val) => {
    //     console.log("val", val);
    //     if (val) {
    //       this.$parent.flag = false;
    //     }
    //   }
    // );
  },
  mounted() {
    if (this.$store.state.appOrH5 !== "H5" && !this.isFromOpenService) {
      this.getToken();
    } else {
      this.checkToken();
    }
    if (process.env.VUE_APP_GAME_VERSION === "officialSite") {
      this.$router.push({
        path: "/officialSite",
      });
    }
    window.addEventListener("popstate", (event) => {
      console.log("返回按键-------------");
      //监听返回按键 无论哪里返回都跳到游戏页
      this.$store.state.flag = false;
    });
    // this.openCustomerService(); // 本地测试使用
    // 注册特定命名空间下的backHandler方法
    dsBridge.register("NativeBridge", {
      backHandler: (params, callback) => {
        if (this.$store.state.flag && this.$route.path !== "/login") {
          this.$dialog.close();
          this.$store.state.flag = false;
        } else {
          this.$dialog
            .confirm({
              title: "退出确认",
              message: "您确定要结束当前游戏吗？",
              messageAlign: "center",
              confirmButtonText: "退出游戏",
              cancelButtonText: "继续游玩",
              confirmButtonColor: "#1989fa",
            })
            .then(() => {
              dsBridge.call("exitApp", function (v) {});
            })
            .catch(() => {});
        }
      },
      getToken: (params, callback) => {
        if (this.$store.state.Authorization) {
          // 标准化返回结构
          return JSON.stringify({
            code: 200,
            data: this.$store.state.Authorization,
            msg: "获取成功",
          });
        } else {
          return JSON.stringify({
            code: 500,
            data: "",
            msg: "token为空",
          });
        }
      },
      openService: (params, callback) => {
        console.log("打开客服页面");
        // 调用时设置标记
        // this.isFromOpenService = true;
        // this.openCustomerService();
      },
    });
    // this.$store.state.appOrH5 === "H5"
    //   ? (this.appOrH5 = false)
    //   : (this.appOrH5 = true);
    // // 设置按钮的初始位置
    // this.setButtonPosition();
    // // 监听窗口大小变化
    // window.addEventListener("resize", this.setButtonPosition);
  },
  beforeDestroy() {
    dsBridge.remove("NativeBridge");
    // // 组件销毁前移除事件监听
    // window.removeEventListener("resize", this.setButtonPosition);
  },
};
</script>

<style lang="less" scoped>
#app {
  margin: 0;
  padding: 0;
}
.background-iframe {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1; /* 确保 iframe 在背景 */
  transform: translateZ(0);
}
.toggle-button1 {
  position: fixed;
  top: 100px;
  left: 150px;
  padding: 10px;
  background-color: #fff; /* 按钮背景色 */
  border-radius: 5px;
  border: 0;
}
.toggle-button {
  position: fixed;
  top: 200px;
  left: 5px;
  padding: 10px;
  background-color: #fff; /* 按钮背景色 */
  border-radius: 5px;
  border: 0;
  // box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* 阴影效果 */
  z-index: 3000; /* 确保按钮在顶层 */
  cursor: move;
  user-select: none;
  width: 40px;
  height: 50px;
  overflow: hidden;
  img {
    // width: 100%;
    // height: 100%;
    // scale: (2);
    width: 204%;
    height: 175%;
    transform: translate(-10px, -11px);
  }
  .jf-icon {
    width: 300%;
    height: 212%;
    transform: translate(-20px, -24px);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
.ad-dialog {
  color: #f76d6c;
}
</style>
